const BASE_URL = process.env.REACT_APP_API_URL+'/backend/api';
const APP_URL = process.env.REACT_APP_BASE_URL;

class ApiError extends Error {
  constructor(status, message, data = null) {
    super(message);
    this.status = status;
    this.data = data;
    this.name = 'ApiError';
    this.validationErrors = data?.errors || data?.message || {};
  }
}

const createApi = (getToken) => {
  const getHeaders = (useToken = true,isFormData = false) => {
    let headers = {};
    if(isFormData){
      headers = {
         
      };
    }else{
      headers = {
        'Content-Type': 'application/json',
          
      };
    }
    
 
    if (useToken) {
      const token = getToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    }

    return headers;
  };

  const handleResponse = async (response) => {
    const data = await response.json();
    
    if (!response.ok) {
      let apiErr = new ApiError(
        response.status,
        data.message || 'An error occurred',
        data
      );
      return { status: response.status, data, error: apiErr };
    }
    
    return { status: response.status, data };
  };

  const call = async (endpoint, method = 'GET', data = null, useToken = true, isFormData = false) => {
   
    try {
      const options = {
        method: method.toUpperCase(),
        headers: getHeaders(useToken, isFormData),
      };
       
      if (data) {
        
        if (isFormData) {
          data.append('app_url', APP_URL);
          options.body = data;
        
        } else {
          data.app_url = APP_URL;
          if (method.toUpperCase() !== 'GET') {
             
            options.body = JSON.stringify(data);
            
          }
        }
      }
   
      const response = await fetch(`${BASE_URL}/${endpoint}`, options);
      return await handleResponse(response);
    } catch (error) {
      const status = error?.response?.status || 500;
      let apiErr = new ApiError(
        status,
        error?.message || 'An error occurred',
        null
      );
      return { status: status, error: apiErr };
    }
  };

  return {
    call,
    // For backward compatibility
    get: (endpoint, useToken = true) => call(endpoint, 'GET', null, useToken),
    post: (endpoint, data, useToken = true) => call(endpoint, 'POST', data, useToken),
    put: (endpoint, data, useToken = true) => call(endpoint, 'PUT', data, useToken),
    delete: (endpoint, useToken = true) => call(endpoint, 'DELETE', null, useToken),
  };
};

export default createApi;
